import { AnalyticsTypeEnum } from '../../../core/enums/analytics-type.enum'
import ShareAnalyticDetailsAuthorMirrorView from './author-mirror/ShareAnalyticDetailsAuthorMirrorView'
import ShareAnalyticDetailsReadershipProfilView from './readership/ShareAnalyticDetailsReadershipProfilView'
import ShareAnalyticDetailsWorkMirrorView from './work-mirror/ShareAnalyticDetailsWorkMirrorView'

const ShareAnalyticDetailsSwitchView = ({
  type,
}: {
  type: AnalyticsTypeEnum
}) => {
  switch (type) {
    case AnalyticsTypeEnum.WORK_MIRROR:
    case AnalyticsTypeEnum.PRIVATE_WORK_MIRROR:
      return <ShareAnalyticDetailsWorkMirrorView />
    case AnalyticsTypeEnum.AUTHOR_MIRROR:
    case AnalyticsTypeEnum.PRIVATE_AUTHOR_MIRROR:
      return <ShareAnalyticDetailsAuthorMirrorView />
    case AnalyticsTypeEnum.READERSHIP_PROFILE:
      return <ShareAnalyticDetailsReadershipProfilView />
    default:
      return null
  }
}

export default ShareAnalyticDetailsSwitchView
